import apiClient from "./apiClient";
import { decodeBase64Json } from "../utils/decodeBase64Json";
const cache = {};

export const getLookupData = async (lt_name, id) => {
  if (cache[lt_name]) {
    return cache[lt_name];
  }

  try {
    const res = await apiClient.post(
      "/DS/customer/get_look_up_data.zjs",
      {
        lt_name: lt_name,
        param1: id
      }
    );

    cache[lt_name] = res.data || [];
    return cache[lt_name];
  } catch (err) {
    console.error(`Lookup ${lt_name} failed:`, err);
    return [];
  }
};
// 'LOCATION'  
// 'OWNER'
// 'TRANSPORT_TYPE'
// 'SHIPMENT_TYPE'
// 'SHIPMENT_TERM'
// 'CURRENCY'
// 'CONTAINER_TYPE'
// 'COMMODITY'
// 'IMDG'
// 'UN_CODE'
//BR_CONTAINER_TYPE
//BR_CONTAINER_COUNT
//PORT
//PAYMENT_TYPE
//PACKAGE_TYPE

export const searchSecondaryBrForCombine = async (primaryBrNumber) => {
  const res = await apiClient.post(
    "/DS/customer/search_secondary_br_for_combine.zjs",
    {
      primary_br_number: String(primaryBrNumber),

    }
  );
  return res.data;
};

export const shoModifyCargoRequest = async (mode, payloadOrSysDocumentId) => {
  const payload =
    typeof payloadOrSysDocumentId === "object" && payloadOrSysDocumentId !== null
      ? { mode, ...payloadOrSysDocumentId }
      : { mode, sys_document_id: String(payloadOrSysDocumentId) };

  const res = await apiClient.post(
    "/DS/customer/modify_cargo_request.zjs",
    payload
  );
  const base64 = res?.data?.[0]?.ResultBase64;
  const decoded = decodeBase64Json(base64);

  const r = decoded?.Result;
  return Array.isArray(r) ? r : r ? [r] : [];
};

export const shoModifyCargoRequestWorkFlow = async (id) => {
  const res = await apiClient.post(
    "/DS/shipping_order/send_modify_cargo_detail_to_workflow.zjs",
    { sys_document_id: id }
  );
  return res?.data;
};


export const shoAmendentRequest = async (sysDocumentId) => {
  const res = await apiClient.post(
    "/DS/customer/cp_get_parties_info.zjs",
    {
      sys_document_id: String(sysDocumentId),
    }
  );
  return res.data;
};

export const changeTypePaymentBl = async (sysDocumentId) => {
  const res = await apiClient.post(
    "/DS/customer/change_type_of_payment_bl_request.zjs",
    {
      sys_document_id: String(sysDocumentId),
    }
  );
  const firstRecord = res?.data?.[0];
  if (firstRecord?.ERROR && firstRecord.ERROR !== "0") {
    return res.data;
  }
  const base64 = firstRecord?.ResultBase64;
  if (!base64) return [];

  try {
    const decodedData = decodeBase64Json(base64);
    return decodedData;
  } catch (error) {
    console.error("Decoding Base64 failed:", error);
    return { ERROR: "1", ERROR_MESSAGE: "Failed to decode server response" };
  }
};
